import QueryTimeslotKinds from 'graphql/queries/QueryTimeslotKinds'
import QueryTimeslotKind from 'graphql/queries/QueryTimeslotKind'
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'

export default class FetchTimeslotKinds
{
	static fetchAll( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) {
		GraphqlGroupedBuilder.addQuery( 'timeslot_kinds', QueryTimeslotKinds, {
			resultPath: [ 'timeslot_kinds' ],
			callbackStart,
			callbackError,
			callbackSuccess,
		})
	}
	
	static fetch( { guid = null, callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) {
		GraphqlGroupedBuilder.addQuery( 'timeslot_kind', QueryTimeslotKind, {
			variables: {
				guid: guid
			},
			resultPath: [ 'timeslot_kind' ],
			callbackStart,
			callbackError,
			callbackSuccess,
		})
	}
}
